// Componentes internos
import API from "../helpers/API"

const FlavourController = {
  fetchOne(flavourUid, productUid, withIngredients = false, withOptionals = false, withUtensilsSizes = false) {
    return API.request("/v1/flavour/one", { flavourUid, productUid, withIngredients, withOptionals, withUtensilsSizes }, "GET")
  },

  fetchFlavourIngredientsMemory(filter = {}, options = {}) {
    const { signal } = options
    let headers = {}
    if (!!filter.companyUid) {
      headers = { Company: filter.companyUid }
    }
    return API.request("/v1/flavour/ingredients/memory", filter, "GET", headers, 30000, 3, signal)
  },

  fetchFlavourOptionalsMemory(filter = {}, options = {}) {
    const { signal } = options
    let headers = {}
    if (!!filter.companyUid) {
      headers = { Company: filter.companyUid }
    }
    return API.request("/v1/flavour/optionals/memory", filter, "GET", headers, 30000, 3, signal)
  },

  fetchOneInitital(filter = {}, options = {}) {
    const { signal } = options
    let headers = {}
    if (!!filter.companyUid) {
      headers = { Company: filter.companyUid }
    }
    return API.request("/v1/flavour/one/initial", filter, "GET", headers, 30000, 3, signal)
  },
}

export default FlavourController
